import { render, staticRenderFns } from "./ngo-admin-add.vue?vue&type=template&id=4b0489aa&scoped=true&"
import script from "./ngo-admin-add.vue?vue&type=script&lang=js&"
export * from "./ngo-admin-add.vue?vue&type=script&lang=js&"
import style0 from "./ngo-admin-add.vue?vue&type=style&index=0&id=4b0489aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0489aa",
  null
  
)

export default component.exports